import React from 'react';
import appDevelopment from '../assests/app_development.png';
import cloudHosting from '../assests/cloud_hosting.png';
import webDevelopment from '../assests/web_development.png';
import aiAutomation from '../assests/ai_automation.png';
import ecommerce from '../assests/ecommerce.png';
import customWebDesign from '../assests/custom_web_design.png';

const Services = () => {
  const services1 = [
    {
      title: 'App Development',
      image: appDevelopment,
      bgColor: '#530404',
      gradient: false,
    },
    {
      title: 'Cloud Consulting',
      image: cloudHosting,
      bgColor: '#0e0f1a',
      gradient: false,
    },
    {
      title: 'Web Development',
      image: webDevelopment,
      bgColor: '#362171',
      bgColorTo: '#7a53af',
      gradient: true,
    },
  ];

  const services2 = [
    {
      title: 'AI Automation',
      image: aiAutomation,
      bgColor: '#684c4c',
      gradient: false,
    },
    {
      title: 'Ecommerce Website',
      image: ecommerce,
      bgColor: '#1e2663',
      gradient: false,
    },
    {
      title: 'Custom Web Design',
      image: customWebDesign,
      bgColor: '#530404',
      bgColorTo: '#834444',
      gradient: true,
    },
  ];

  return (
    <section id='services' className='bg-neutral-100 py-12 sm:py-16 lg:py-20'>
      <div className='container mx-auto px-4 sm:px-6 lg:px-8'>
        {/* Services Heading */}
        <div className='flex items-center justify-center mb-12 sm:mb-16'>
          <h2 className='text-[48px] font-semibold text-black text-center'>
            Services
          </h2>
        </div>

        {/* First Services Row */}
        <div className='max-w-[1000px] mx-auto mb-12 sm:mb-16 lg:mb-20 px-2 sm:px-4'>
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-[81px]'>
            {services1.map((service, index) => (
              <div key={index} className='flex flex-col items-center'>
                <div
                  className='w-full max-w-[280px] h-[400px] rounded-[30px] overflow-hidden shadow-lg mb-4 flex items-center justify-center p-4'
                  style={
                    service.gradient
                      ? {
                          background: `linear-gradient(to bottom, ${service.bgColor} 11.538%, ${service.bgColorTo})`,
                        }
                      : { backgroundColor: service.bgColor }
                  }
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className='w-3/4 h-3/4 object-contain'
                  />
                </div>
                <h3 className='text-[32px] font-semibold text-black text-center'>
                  {service.title}
                </h3>
              </div>
            ))}
          </div>
        </div>

        {/* Second Services Row */}
        <div className='max-w-[1000px] mx-auto px-2 sm:px-4'>
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-[81px]'>
            {services2.map((service, index) => (
              <div key={index} className='flex flex-col items-center'>
                <div
                  className='w-full max-w-[280px] h-[400px] rounded-[30px] overflow-hidden shadow-lg mb-4 flex items-center justify-center p-4'
                  style={
                    service.gradient
                      ? {
                          background: `linear-gradient(to bottom, ${service.bgColor} 11.538%, ${service.bgColorTo})`,
                        }
                      : { backgroundColor: service.bgColor }
                  }
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className='w-3/4 h-3/4 object-contain'
                  />
                </div>
                <h3 className='text-[32px] font-semibold text-black text-center'>
                  {service.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
